var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatientIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 61,
    viewBox: "0 0 54 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 48.5L33 48.5M42 39.5V57.5M14.0464 36.5C16.8973 38.3955 20.3196 39.5 23.9998 39.5C26.1037 39.5 28.1233 39.139 30 38.4757M22.5 57.5H7.8C6.11984 57.5 5.27976 57.5 4.63803 57.173C4.07354 56.8854 3.6146 56.4265 3.32698 55.862C3 55.2202 3 54.3802 3 52.7V45.5C3 40.5294 7.02944 36.5 12 36.5H13.5M36 15.5C36 22.1274 30.6274 27.5 24 27.5C17.3726 27.5 12 22.1274 12 15.5C12 8.87258 17.3726 3.5 24 3.5C30.6274 3.5 36 8.87258 36 15.5Z",
    stroke: "#11C0F2",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientIcon);
export default __webpack_public_path__ + "static/media/PatientIcon.bb902cec25aac4f80fb39b732cbdfc88.svg";
export { ForwardRef as ReactComponent };